import { id } from "date-fns/locale";
import GenericModalContainer from "../../../components/Modals/GenericModalContainer";
import {
    DeclarationsService,
    Delaration,
} from "../../../services/api/declarationsService";
import ManageSingleDeclarations from "./ManageSingleDeclarations/ManageSingleDeclarations";
import { useState } from "react";
import ManageMultipeDeclarations from "./ManageMultipleDeclarations/ManageMultipleDeclarations";

type Props = (
    | {
          caseType: "AddSingle";
      }
    | {
          caseType: "Edit";
          id: string;
      }
    | {
          caseType: "UpsertMultiple";
      }
) & {
    close: () => void;
    uuid: string;
    pid: string;
    refresh: () => void;
};

const ManageDeclarations = (props: Props) => {
    const [declaration, setDeclaration] = useState<Delaration | null>(null);

    if (props.caseType === "Edit" && !declaration) {
        debugger
        DeclarationsService.getDeclaration(
            props.id,
            props.pid,
            props.uuid
        ).then((response) => {
            setDeclaration(response);
        });
    }
    if (props.caseType === "AddSingle") {
        return (
            <GenericModalContainer
                close={props.close}
                headingText={"Add Declaration"}
            >
                <ManageSingleDeclarations
                    uuid={props.uuid}
                    pid={props.pid}
                    caseType={"AddSingle"}
                    close={props.close}
                    refresh={props.refresh}
                />
            </GenericModalContainer>
        );
    } else if (props.caseType === "Edit") {
        if (!declaration) {
            return <>Loading ...</>;
        }
        return (
            <GenericModalContainer
                close={props.close}
                headingText={"Edit Declaration"}
            >
                <ManageSingleDeclarations
                    uuid={props.uuid}
                    pid={props.pid}
                    caseType={"Edit"}
                    close={props.close}
                    declaration={{
                        ...declaration,
                        id: props.id,
                    }}
                    refresh={props.refresh}
                />
            </GenericModalContainer>
        );
    } else if (props.caseType === "UpsertMultiple") {
        return (
            <GenericModalContainer
                close={props.close}
                headingText={"Add Multiple Declarations"}
            >
                <ManageMultipeDeclarations 
                    close={props.close}
                    uuid={props.uuid}
                    pid={props.pid}
                    refresh={props.refresh}
                />
            </GenericModalContainer>
        );
    }

    return <></>;
};
export default ManageDeclarations;
